/**
 * Vertical "similar" label on the left edge of a note: a review item card
 * or an earlier-comment bubble. Same yellow for every note in a similar
 * set. The parent is `position: relative` and pads its left side by
 * `SIMILAR_SPINE_PX` while the spine shows.
 */
import { Tooltip } from "antd"

import { useThemeContext } from "#contexts/ThemeContextProvider"

import { COMMENT_HISTORY_SIMILAR } from "./reviewCardLayout"

export const SIMILAR_SPINE_PX = 16

const SimilarSpine = ({
  similar,
  reason,
  innerRadius = 4,
}: {
  similar: boolean
  reason?: string | null
  /** The parent's corner radius minus its left border width. */
  innerRadius?: number
}) => {
  const theme = useThemeContext()
  if (!similar) return null
  return (
    <Tooltip title={reason || "Similar to another note for this family"}>
      <div
        data-testid="sr-similar-spine"
        aria-label="similar"
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          width: SIMILAR_SPINE_PX,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: `${innerRadius}px 0 0 ${innerRadius}px`,
          backgroundColor: COMMENT_HISTORY_SIMILAR,
          color: theme.black,
          overflow: "hidden",
        }}
      >
        <span
          style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            fontSize: 10,
            fontWeight: 700,
            lineHeight: 1,
            letterSpacing: 1,
            whiteSpace: "nowrap",
          }}
        >
          similar
        </span>
      </div>
    </Tooltip>
  )
}

export default SimilarSpine
